import React from 'react';
import FighterDetails from './FighterDetails';

const ViewFighterDetailsPage = () => {
    return <FighterDetails />;
};

export default ViewFighterDetailsPage;